import React from 'react';
import { LockIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { CtaButton } from './CtaButton';
import { TrustStrip } from './TrustStrip';
import { BRAND, MAIN_MOCKUP, MOCKUP_ALT, pricing } from '../data/eatWellContent';
export function FinalOfferSection() {
  return <section className="w-full border-t border-champagne/25 bg-black" aria-labelledby="final-title" data-id="element-69" data-mp="2o07ahz0qlr8r">
      <div className="mx-auto grid max-w-4xl items-center gap-8 px-5 py-12 sm:grid-cols-2 sm:gap-10 sm:py-16" data-id="element-70" data-mp="1qdi0p2zsmacc">
        <img src={MAIN_MOCKUP} alt={MOCKUP_ALT} className="mx-auto w-full max-w-sm sm:max-w-none" width={1536} height={1024} data-id="element-71" data-mp="1vbrvhchlv8xf" />

        <div className="text-center sm:text-left" data-id="element-72" data-mp="251v1qedqmjdp">
          <CountdownTimer label="Price closes in" className="sm:text-left [&>div]:justify-center sm:[&>div]:justify-start" data-id="element-73" data-mp="17lp7p8kq4p4m" />

          <h2 id="final-title" className="mt-7 font-display text-[1.7rem] font-semibold uppercase leading-tight text-ivory-50 sm:text-[2.25rem]" data-id="element-74" data-mp="1cj7kja1v3ohw">
            {BRAND}
          </h2>
          <p className="mt-2 text-[12px] uppercase tracking-[0.14em] text-body" data-id="element-75" data-mp="27kuxivdqigj2">
            5 Volumes + 5 Bonuses · All meal categories
          </p>

          <p className="mt-5 border-t border-charcoal-600 pt-5 text-[12px] uppercase tracking-[0.12em] text-muted line-through" data-id="element-76" data-mp="1xtqjbxvvuzpa">
            {pricing.regularPrice}
          </p>
          <p className="mt-1 font-display text-6xl font-semibold leading-none text-ivory-50 sm:text-7xl" data-id="element-77" data-mp="1osjzpfxxt8rt">
            {pricing.today}
            <span className="ml-2 align-middle font-sans text-xs font-semibold uppercase tracking-[0.14em] text-muted" data-id="element-78" data-mp="1jtyybd6y8j1s">
              USD
            </span>
          </p>

          <div className="mt-6 flex justify-center sm:justify-start" data-id="element-79" data-mp="3e7qg4zzfm98b">
            <CtaButton target="checkout" size="md" data-id="element-80" data-mp="3e4uilcrhxmke" />
          </div>
          <p className="mt-3 flex items-center justify-center gap-1.5 text-[10px] font-medium uppercase tracking-[0.14em] text-muted sm:justify-start" data-id="element-81" data-mp="398n9xc7ptwyr">
            <LockIcon className="h-3 w-3 text-champagne" strokeWidth={1.75} aria-hidden="true" data-id="element-82" data-mp="1c9epfwc15yrf" />
            100% Secure payment
          </p>
          <TrustStrip variant="full" className="mt-3 sm:justify-start" data-id="element-83" data-mp="xmd2bdl8wduw" />
        </div>
      </div>
    </section>;
}